export default function generateCSSSupportRule(support, cssRules) {
  return "@supports " + support + "{" + cssRules + "}";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-monolithic/node_modules/fela-utils/es/generateCSSSupportRule.js
// module id = 319
// module chunks = 0